import { Tagß, type TagßProps } from '@otter-ai/den-components';
import { useTranslations } from 'next-intl';

export type EnterpriseTagProps = Pick<TagßProps, 'size'>;

export function EnterpriseTag({ size = 'md' }: EnterpriseTagProps) {
  const t = useTranslations('settings:integrations.tags');
  return (
    <Tagß data-testid="enterprise-tag" size={size} color="blue">
      {t('enterprise')}
    </Tagß>
  );
}
